import api from '../token';

export const DasboardPedido = async () => {
  try {
    const response = await api.post('/CountDashboardAll');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produtos:', error);
    return [];
  }
};

